import type { KitManifest } from '../../shared/discoverKits';

const manifest: KitManifest = {
    slug: 'general',
    context: 'size2mix',
    name: 'Général',
    description:
        "Section 'Général' d'un réseau Nemo : page de synthèse (KPIs réseau, infos générales, nom, timezone, externalisation de l'optimisation) et onglet Paramètres (operating points, profils simples, catalogue de tuyaux, critères de dimensionnement, chat).",
    status: 'planned',
    owner: 'platform-team',
    tags: ['general', 'synthesis', 'parameters', 'kpi', 'network', 'chat'],
    nemoSources: [
        {
            label: 'Synthèse',
            path: 'apps/frontend-next/src/ui/views/pages/network/general/synthesis/Synthesis.tsx',
            note: 'Page racine de la synthèse réseau. Compose NetworkInformation + NetworkKpiTables + GeneralInformations.',
        },
        {
            label: 'KPI réseau',
            path: 'apps/frontend-next/src/ui/views/pages/network/general/synthesis/NetworkKpiTables.tsx',
            note: 'Tables agrégées (assets, contrats, mix). À reproduire avec @shared/DataTable.',
        },
        {
            label: 'Champs métadonnées réseau',
            path: 'apps/frontend-next/src/ui/views/pages/network/general/synthesis/',
            note: 'NetworkNameField, NetworkTimezoneField, NetworkUseExternalOptimisationServiceField (champs inline éditables).',
        },
        {
            label: 'Paramètres',
            path: 'apps/frontend-next/src/ui/views/pages/network/general/parameters/Parameters.tsx',
            note: "Onglet Paramètres : OperatingPoints, SimpleProfiles, PipesCatalogue, SizingCriterias.",
        },
        {
            label: 'Chat',
            path: 'apps/frontend-next/src/ui/views/pages/network/general/chat/',
            note: "Sous-section Chat (alpha). Layout dédié.",
        },
    ],
    sharedComponents: [
        '@shared/PrototypeStudioLayout',
        '@shared/DataTable (KPI tables, operating points, pipes catalogue)',
        '@shared/EditableField (champs inline name/timezone)',
        '@shared/InfoRow (lignes clé/valeur dans les blocs synthèse)',
        '@shared/NavLinkTabs (sous-navigation Synthèse / Paramètres / Chat)',
        '@shared/AccordionItem (sections rétractables côté Paramètres)',
    ],
    views: [
        {
            id: 'synthesis-overview',
            label: 'Synthèse — Vue générale',
            description:
                "KPIs réseau + infos générales (nom, timezone, options). Page d'entrée d'un réseau.",
        },
        {
            id: 'synthesis-kpi-tables',
            label: 'Synthèse — Tables KPI',
            description:
                'Tables agrégées (assets, contrats, mix énergétique, polluants).',
        },
        {
            id: 'parameters-operating-points',
            label: 'Paramètres — Operating points',
            description:
                "Définition des points de fonctionnement opérationnels du réseau.",
        },
        {
            id: 'parameters-simple-profiles',
            label: 'Paramètres — Profils simples',
            description:
                'Profils de charge/disponibilité simplifiés réutilisables.',
        },
        {
            id: 'parameters-pipes-catalogue',
            label: 'Paramètres — Catalogue de tuyaux',
            description:
                "Catalogue des types de tuyaux (diamètre, matériau, U-value).",
        },
        {
            id: 'parameters-sizing-criterias',
            label: 'Paramètres — Critères de dimensionnement',
            description:
                "Critères utilisés par les optimisations de sizing (températures cibles, marges).",
        },
        {
            id: 'chat',
            label: 'Chat (alpha)',
            description:
                "Sous-section conversationnelle. Layout dédié, à considérer comme exploratoire.",
        },
    ],
    notes: `
- Manifest initial : pas encore de screenshots ni de kit partagé. À enrichir
  dès qu'un premier proto cible cette section (ajouter PNG dans
  src/kits/general/screenshots/ et lier via views[].screenshot).
- Pas de canvas/graphe ici → réutilise les briques de base (DataTable,
  EditableField, InfoRow, AccordionItem). Pas de @shared/general/* à créer
  tant qu'aucun pattern propre n'émerge.
`.trim(),
};

export default manifest;
